export const Header = (props) => {
  return (
    <header className={"order-2 "}>
      <h1 className={"text-5xl"}>Fabio Vaccaro C.V</h1>
    </header>
  );
};
